import { CheckboxInput, FormItem } from '@framework/form';
import { StyledDrawerCollapse } from '@framework/ui';
import { Collapse } from 'antd';
import React from 'react';
import { Datatype } from '../../../../expressions/datatype/Datatype';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { CommonConfigComponent } from '../../inputs/common/CommonInputConfigComponent';
import { IPaymentRowWidget } from './IPaymentRowWidget';
import { PaymentRowFieldConfig } from './components/PaymentRowFieldConfig';
const { Panel } = Collapse;

export interface IPaymentRowConfigComponentProps
  extends IWidgetComponentProps<IPaymentRowWidget> {}

export function PaymentRowConfigComponent(
  props: IPaymentRowConfigComponentProps,
) {
  return (
    <StyledDrawerCollapse
      defaultActiveKey={['general', 'config', 'fields']}
      ghost
    >
      <Panel header="Impostazioni Generali" key="general">
        <CommonConfigComponent
          {...props}
          hideConfigDefaultValue
          hideConfigHelpText
          hideConfigPlaceholder
        />
      </Panel>

      <Panel header="Impostazioni Voce di Pagamento" key="config">
        <FormItem name="canBeExcluded">
          <CheckboxInput name={'canBeExcluded'}>
            Abilita la possibilità di escludere la voce di costo
          </CheckboxInput>
        </FormItem>

        <FormItem
          name="showReport"
          help="Mostra il resoconto della singola voce di pagamento (imponibile, iva, totale)"
        >
          <CheckboxInput name={'showReport'}>Mostra resoconto</CheckboxInput>
        </FormItem>
      </Panel>

      <Panel header="Impostazioni Campi" key="fields">
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
          }}
        >
          <PaymentRowFieldConfig
            name="description"
            title={'Descrizione'}
            widgetId={props.widget.id}
            datatype={Datatype.String}
          />
          <PaymentRowFieldConfig
            name="baseUnitAmount"
            title={'Importo Unitaio di Listino'}
            widgetId={props.widget.id}
            datatype={Datatype.Number}
          />
          <PaymentRowFieldConfig
            name="quantity"
            title={'Quantità'}
            widgetId={props.widget.id}
            datatype={Datatype.Number}
          />
          <PaymentRowFieldConfig
            name="unit"
            title={'Unità di misura'}
            widgetId={props.widget.id}
            datatype={Datatype.String}
          />
          <PaymentRowFieldConfig
            name="vat"
            title={'Percentuale IVA'}
            widgetId={props.widget.id}
            datatype={Datatype.Number}
          />
          <PaymentRowFieldConfig
            name="discount"
            title={'Percentuale Sconto/Esenzione'}
            widgetId={props.widget.id}
            datatype={Datatype.Number}
          />
        </div>
      </Panel>
    </StyledDrawerCollapse>
  );
}
